import { call } from '../core'
import { HostType } from './requestPinAuth'

export interface ISetDebitCardPincodeParams {
  hostType: HostType
  confirmApiUrl: string
  request: string // JSON string
}

export interface ISetDebitCardPincodeInfo {
  isSuccess: boolean
  validatePin: string
  confirmPin: string
  response: string // JSON string
}

export interface ISetDebitCardPincodeResult {
  result: ISetDebitCardPincodeInfo | null
}

export function setDebitCardPincode(
  params: ISetDebitCardPincodeParams,
): Promise<ISetDebitCardPincodeResult | Error> {
  return call('finSetDebitCardPincode', params)
}
